import { GetFunc } from "../../../Map/types";

export const linesSizes = {
  md: {
    left: {
      width: 465.5,
      height: 148.4
    },
    right: {
      width: 287.7,
      height: 83.3
    }
  },
  lg: {
    left: {
      width: 665,
      height: 212
    },
    right: {
      width: 411,
      height: 119
    }
  }
}

export const truckSizes = { width: { md: "54px", lg: "77px", }, height: { md: "54px", lg: "77px" } }
export const individualSizes = { width: { md: "94px", lg: "135px" }, height: { md: "94px", lg: "135px" } }

export const getLeftOptions = (getWidth: GetFunc, getHeight: GetFunc) => ({
  truck: {
    from: {
      left: getWidth(-200),
      top: getHeight(-38),
      transform: "rotate(0deg)",
      opacity: 1,
    },
    to: [
      {
        top: getHeight(-38),
        left: getWidth(350),
      },
      {
        transform: "rotate(90deg)",
      },
      {
        top: getHeight(171),
        left: getWidth(350),
      },
      {
        transform: "rotate(0deg)",
      },
      {
        top: getHeight(171),
        left: getWidth(800),
        opacity: 0,
      },
    ],
    config: {
      duration: 1000,
    },
    loop: {
      from: {
        left: getWidth(-200),
        top: getHeight(-38),
        transform: "rotate(0deg)",
        opacity: 1,
      },
      delay: 8000,
    },
  },
  car: {
    from: {
      top: getHeight(140),
      left: getWidth(800),
      opacity: 0,
      transform: "rotate(360deg)",
    },
    to: [
      {
        top: getHeight(140),
        left: getWidth(324),
        opacity: 1,
        delay: 7000,
      },
      {
        transform: "rotate(450deg)",
      },
      {
        top: getHeight(-70),
        left: getWidth(324),
      },
      {
        transform: "rotate(360deg)",
      },
      {
        left: getWidth(-200),
        top: getHeight(-70),
      },
      {
        transform: "rotate(0deg)",
      },
    ],
    config: {
      duration: 1000,
    },
    loop: {
      from: {
        top: getHeight(140),
        left: getWidth(800),
        opacity: 0,
        transform: "rotate(360deg)",
        delay: 3000,
      },
    },
  },
})

export const getRightOptions = (getWidth: GetFunc, getHeight: GetFunc) => ({
  car: {
    from: {
      right: getWidth(-200),
      top: getHeight(-70),
      transform: "rotate(0deg)",
      opacity: 1,
    },
    to: [
      {
        top: getHeight(-70),
        right: getWidth(130),
      },
      {
        transform: "rotate(-90deg)",
      },
      {
        top: getHeight(50),
        right: getWidth(130),
        delay: 1000,
      },
      {
        transform: "rotate(0deg)",
      },
      {
        top: getHeight(50),
        right: getWidth(800),
        opacity: 0,
      },
    ],
    config: {
      duration: 1000,
    },
    loop: {
      from: {
        right: getWidth(-200),
        top: getHeight(-70),
        transform: "rotate(0deg)",
        opacity: 1,
      },
      delay: 7000,
    },
  },
  truck: {
    from: {
      top: getHeight(80),
      right: getWidth(800),
      opacity: 0,
      transform: "rotate(0deg)",
    },
    to: [
      {
        top: getHeight(80),
        right: getWidth(155),
        opacity: 1,
        delay: 6000,
      },
      {
        transform: "rotate(-90deg)",
      },
      {
        top: getHeight(-40),
        right: getWidth(155),
      },
      {
        transform: "rotate(0deg)",
      },
      {
        right: getWidth(-200),
        top: getHeight(-40),
      },
    ],
    config: {
      duration: 1000,
    },
    loop: {
      from: {
        top: getHeight(50),
        right: getWidth(800),
        opacity: 0,
      },
      delay: 2000,
    },
  },
})

export const getOptions = (getWidth: GetFunc, getHeight: GetFunc) => ({
  left: {
    truck: {
      from: {
        left: getWidth(-200),
        top: getHeight(-38),
        transform: "rotate(0deg)",
        opacity: 1,
      },
      to: [
        {
          top: getHeight(-38),
          left: getWidth(346),
        },
        {
          transform: "rotate(90deg)",
        },
        {
          top: getHeight(171),
          left: getWidth(346),
        },
        {
          transform: "rotate(0deg)",
        },
        {
          top: getHeight(171),
          left: getWidth(800),
          opacity: 0,
        },
      ],
      config: {
        duration: 1000,
      },
      loop: {
        from: {
          left: getWidth(-200),
          top: getHeight(-38),
          transform: "rotate(0deg)",
          opacity: 1,
        },
        delay: 8000,
      },
    },
    car: {
      from: {
        top: getHeight(140),
        left: getWidth(800),
        opacity: 0,
        transform: "rotate(360deg)",
      },
      to: [
        {
          top: getHeight(140),
          left: getWidth(320),
          opacity: 1,
          delay: 7000,
        },
        {
          transform: "rotate(450deg)",
        },
        {
          top: getHeight(-70),
          left: getWidth(320),
        },
        {
          transform: "rotate(360deg)",
        },
        {
          left: getWidth(-200),
          top: getHeight(-70),
        },
        {
          transform: "rotate(0deg)",
        },
      ],
      config: {
        duration: 1000,
      },
      loop: {
        from: {
          top: getHeight(140),
          left: getWidth(800),
          opacity: 0,
          transform: "rotate(360deg)",
          delay: 3000,
        },
      },
    },
  },
  right: {
    car: {
      from: {
        right: -200,
        top: -70,
        transform: "rotate(0deg)",
        opacity: 1,
      },
      to: [
        {
          top: -70,
          right: 126,
        },
        {
          transform: "rotate(-90deg)",
        },
        {
          top: 50,
          right: 126,
          delay: 1000,
        },
        {
          transform: "rotate(0deg)",
        },
        {
          top: 50,
          right: 800,
          opacity: 0,
        },
      ],
      config: {
        duration: 1000,
      },
      loop: {
        from: {
          right: -200,
          top: -70,
          transform: "rotate(0deg)",
          opacity: 1,
        },
        delay: 7000,
      },
    },
    truck: {
      from: {
        top: 80,
        right: 800,
        opacity: 0,
        transform: "rotate(0deg)",
      },
      to: [
        {
          top: 80,
          right: 150,
          opacity: 1,
          delay: 6000,
        },
        {
          transform: "rotate(-90deg)",
        },
        {
          top: -40,
          right: 150,
        },
        {
          transform: "rotate(0deg)",
        },
        {
          right: -200,
          top: -40,
        },
      ],
      config: {
        duration: 1000,
      },
      loop: {
        from: {
          top: 50,
          right: 800,
          opacity: 0,
        },
        delay: 2000,
      },
    },
  },
});
